import awsConfig from '../aws-exports';

/**
 * Determines the environment based on AWS Amplify configuration
 * This aligns with the git branch:
 * - main branch uses production Amplify environment → returns 'production'
 *
 * @returns 'production', 'staging' or 'development'
 */
export function getEnvironment(): 'production' | 'development' | 'staging' | 'local' {
  // Check if we are running locally
  if (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  ) {
    return 'development';
  }

  // Check if the AWS config contains production domains
  const configStr = JSON.stringify(awsConfig).toLowerCase();

  if (configStr.includes('staging')) {
    return 'staging';
  }

  if (configStr.includes('development')) {
    return 'development';
  }

  return 'production';
}
